module.exports = __webpack_public_path__ + "static/media/1024px-Roblox_logo.svg.14c55b7b.png";